import * as React from 'react'

import { useInViewport } from '@/hooks/useInViewport'
import { useProductListTracking } from '@/providers/ProductListTrackingProvider'

import type { ListItem } from '@/lib/eventBus/trackingEvents'

interface ItemListImpression {
  product?: ListItem['product']
  priceData?: ListItem['priceData']
  isPriceShown: boolean
  isPriceLoading: boolean
}

export const useItemListImpression = <T extends Element>({
  product,
  priceData,
  isPriceShown,
  isPriceLoading,
}: ItemListImpression) => {
  const listTracking = useProductListTracking()
  const [impressionRef, isSeen] = useInViewport<T>('0px')
  const isPriceSettled = !isPriceShown || !isPriceLoading

  React.useEffect(() => {
    if (listTracking && product && isSeen && isPriceSettled) {
      listTracking.reportItemSeen({ product, priceData })
    }
  }, [listTracking, product, priceData, isSeen, isPriceSettled])

  return impressionRef
}
